export default __webpack_public_path__ + "static/media/philadelphia.f239bd0b.png";